module.exports = __webpack_public_path__ + "static/media/rsm-add-large.0265183a.svg";